import { render, staticRenderFns } from "./ActivityDetailScreen.vue?vue&type=template&id=3bd76ad0&scoped=true&"
import script from "./ActivityDetailScreen.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd76ad0",
  null
  
)

export default component.exports